import type { HarmonyPackageBoardColumn } from '@rhythmic/db/types'
import type { UseLiveQueryReturn } from '@tanstack/vue-db'
import { useLiveQuery } from '@tanstack/vue-db'
import { useRhythmicLogger } from '#imports'
import { HARMONY_PACKAGE_BOARD_COLUMN_TABLE } from '../collections'
import { useCollection } from '../composables/useCollection'

const logger = useRhythmicLogger('useColumnsByBoardId')

export function useColumnsByBoardId(boardId: string): UseLiveQueryReturn<HarmonyPackageBoardColumn> | undefined {
  if (!boardId) return undefined

  const acquisition = useCollection<HarmonyPackageBoardColumn>(HARMONY_PACKAGE_BOARD_COLUMN_TABLE, {
    board_id: boardId,
  })

  const query = useLiveQuery((builder) =>
    builder.from({ column: acquisition.collection }).orderBy(({ column }) => column.position, 'asc'),
  )
  logger.debug('useColumnsByBoardId query created', { boardId })
  return query
}
